<template>
  <b-container class="newsletter-massime">

    <loading :active.sync="loading" 
      :can-cancel="false"
      :is-full-page="true"></loading>

    <Menu></Menu>

    <b-row class="mt-5">
        <b-col sm="2"></b-col>
        <b-col sm="8" class="text-center">
            <b-row>
                <b-col>
                    <h4>Newsletter</h4>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    Se vuoi ricevere gratuitamente un'email settimanale con le ultime massime aggiunte, inserisci qui sotto la tua email.
                </b-col>
            </b-row>
            <b-row class="mt-3 px-sm-5">
                <b-form-input v-model="text" type="email" placeholder="Inserisci la tua email"></b-form-input>
            </b-row>
            <b-row class="mt-2 justify-content-center">
                <b-button @click="addEmail()" variant="success">Iscrimi alla newsletter</b-button>
            </b-row>            
        </b-col>
    </b-row>
  </b-container>
</template>

<script>

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import api from '../../services/service.js'
import utils from '../../services/utils.js';

import Menu from './Menu.vue';

export default {
  name: 'newsletterMassime',
  components: {
    Loading,
    Menu
  },
  data () {
    return {
        loading: false,
        text: ''
    }
  },
  methods: {
    async addEmail() {
        let data = {
            'email': this.text
        }
        await api.execute('post', 'newsletter/iscrizionepubblica', data);
        alert("Iscrizione avvenuta con successo!")
    }
  },
  async created() {
    this.$parent._data.loaded = true;
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pubblica/Newsletter.vue